module.exports = __webpack_public_path__ + "img/user-fill.0877239b.svg";